module.exports = __webpack_public_path__ + "img/media-add.10cee4ce.svg";